import CapaAvatar from './CapaAvatar';
export default CapaAvatar;
